import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import ThreadDashboard from "./components/ThreadDashboard";

const WebSocketComponent = () => {

  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const wsUrl = `${protocol}//${window.location.host}/ws`


    const ws = new WebSocket(wsUrl);

    ws.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data);
        
        if (parsed.type === 'stop') {
          // CONSEIL : On passe les données finales à la route /results
          // Elles seront accessibles via useLocation() dans PageResult
          navigate('/results');
          return;
        }

        // On stocke directement l'objet
        setData(parsed);
      } catch (error) {
        console.error("Erreur de parsing:", error);
      }
    };

    return () => {
      ws.close();
    };
  }, [navigate]);

  return (
    <>
      <ThreadDashboard data={data} />
    </>
  );
};

export default WebSocketComponent;
